import http from "./httpService";

const apiEndpoint = "/api/term-data";

function create(data) {
  return http.post(apiEndpoint, data);
}

function update(data) {
  return http.put(apiEndpoint, data);
}

function get(id) {
  return http.get(`${apiEndpoint}/${id}`);
}
function getAll() {
  return http.get(apiEndpoint);
}

function getAllByProgram(id) {
  return http.get(`${apiEndpoint}/program/${id}`);
}

function getAllByProgramAndInstitute(id,instituteId) {
  return http.get(`${apiEndpoint}/program/${id}/institute/${instituteId}`);
}

function getAllList() {
  return http.get(apiEndpoint + "/list");
}

function deleteById(id) {
  return http.delete(`${apiEndpoint}/${id}`);
}

export default {
  create,
  update,
  get,
  getAll,
  getAllByProgram,
  getAllByProgramAndInstitute,
  getAllList,
  deleteById,
};
